import React, { useContext, useEffect, useState } from 'react';

import { Link } from 'react-router-dom';

// styles
import styles from "./CardsSlider.module.css"

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// Modal
import FastViewModal from '../FastViewModal/FastViewModal';

// images
import bedIcon from "../../../assets/img/DashboardICons/bedIcon.svg"
import meterIcon from "../../../assets/img/DashboardICons/meterIcon.svg"
import buildingIcon from "../../../assets/img/DashboardICons/buildingIcon.svg"
import locationIcon from "../../../assets/img/DashboardICons/locationIcon.svg"
import phoneIcon from "../../../assets/img/HomePage/phoneIconBlue.svg"
import axios from 'axios';
import { UserContext } from '../../Context/UserContextProvider';

const   HomeFilesSlider = (props) => {
    const { userToken, userData, permissions } = useContext(UserContext);
    const e2p = s => s?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
    const [modalData, setModalData] = useState({
        show: false,
        id: "",
        loading: true
    });
    let [categoriesData, setCategoriesData] = useState([]);

    useEffect(() => {
        axios.get("Category", {
            headers: {
                authorization: "Bearer " + userToken
            }
        }).then((res) => {
            setCategoriesData(res.data?.data || []);
        });
    }, []);

    const modalHandler = (id) => {
        setModalData((prev) => {
            return { ...prev, id: id, show: true };
        })
    }

    function getParentCategory(categoryId){
        let parentId = 0;
        categoriesData.forEach((category) => {
            if(category.id == categoryId){
                parentId = category.parentId;
            }
        });

        return parentId;
    }

    const shopCategories = [304, 280];
    const hotelCategories = [278, 291];
    const gasStationCategories = [309, 316];
    const landCategories = [273, 277, 281, 284, 287, 302, 305, 308, 312, 315, 517];
    const industrialCategories = [311, 312, 313, 314, 318, 319, 320, 321];

    function getFieldsBasedOnType(fileData){
        let fileCategory = fileData.categoryId;
        if (shopCategories.includes(getParentCategory(fileCategory)) || gasStationCategories.includes(getParentCategory(fileCategory)) || hotelCategories.includes(getParentCategory(fileCategory))){
            return <>
                    <div className='d-flex align-items-center justify-content-center flex-column ms-0'>
                        <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                            <img className="ms-2" src={meterIcon} alt="icon" />
                            <div className={styles.card_text2}>
                                متراژ دهنه: {e2p(fileData.meterageGate?.toString())} متر
                            </div>
                        </div>
                        <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                            <img className="ms-2" src={meterIcon} alt="icon" />
                            <div className={styles.card_text2}>
                                متراژ کف: {e2p(fileData.meterageBase?.toString())} متر
                            </div>
                        </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-center flex-column me-0'>
                        <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                            <img className="ms-2" src={meterIcon} alt="icon" />
                            <div className={styles.card_text2}>
                                متراژ کل: {e2p(fileData.meterage?.toString())} متر
                            </div>
                        </div>
                        <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                            <img className="ms-2" src={locationIcon} alt="icon" />
                            <div className={styles.card_text2}>
                                {fileData.address.zone}
                            </div>
                        </div>
                    </div>
                </>
        }
        if (landCategories.includes(getParentCategory(fileCategory))){
            return <>
                    <div className='d-flex align-items-center justify-content-center flex-column ms-0'>
                        <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                            <img className="ms-2" src={meterIcon} alt="icon" />
                            <div className={styles.card_text2}>
                                متراژ کل: {e2p(fileData.meterage?.toString())} متر
                            </div>
                        </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-center flex-column me-0'>
                        <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                            <img className="ms-2" src={locationIcon} alt="icon" />
                            <div className={styles.card_text2}>
                                {fileData.address.zone}
                            </div>
                        </div>
                    </div>
                </>
        }
        if (industrialCategories.includes(getParentCategory(fileCategory))){
            return <>
                    <div className='d-flex align-items-center justify-content-center flex-column me-0'>
                        <div className='d-flex justify-content-center align-items-center mt-2 mb-2' dir='rtl'>
                            <img className="ms-2" src={meterIcon} alt="icon" />
                            <div className={styles.card_text2}>
                                متراژ کل: {e2p(fileData.meterage?.toString())} متر
                            </div>
                        </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-center flex-column me-0'>
                        <div className='d-flex justify-content-center align-items-center mt-2 mb-2' dir='rtl'>
                            <img className="ms-2" src={locationIcon} alt="icon" />
                            <div className={styles.card_text2}>
                                {fileData.address.zone}
                            </div>
                        </div>
                    </div>
                </>
        }
        return <>
            <div className='d-flex align-items-center justify-content-center flex-column ms-0'>
                <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                    <img className="ms-2" src={bedIcon} alt="icon" />
                    <div className={styles.card_text2}>
                        {e2p(fileData.roomCount?.toString())} خوابه
                    </div>
                </div>
                <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                    <img className="ms-2" src={meterIcon} alt="icon" />
                    <div className={styles.card_text2}>
                        متراژ کل: {e2p(fileData.meterage?.toString())} متر
                    </div>
                </div>
            </div>
            <div className='d-flex align-items-center justify-content-center flex-column me-0'>
                <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                    <img className="ms-2" src={buildingIcon} alt="icon" />
                    <div className={styles.card_text2}>
                        {fileData?.floor == "0" ?
                            "همکف"
                            :
                            fileData?.floor == "-1" ?
                                "زیرزمین"
                                :
                                <>
                                    طبقه {e2p(fileData.floor?.toString())}
                                </>
                        }
                    </div>
                </div>
                <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                    <img className="ms-2" src={locationIcon} alt="icon" />
                    <div className={styles.card_text2}>
                        {fileData.address.zone}
                    </div>
                </div>
            </div>
        </>
    }

    // SwiperCore.use([Autoplay, Pagination]);

    return (
        <>
        <style type="text/css">
            {`
                .swiper {
                    width: 100%;
                }
                .swiper-pagination {
                    bottom: 0 !important;
                }

                .swiper-wrapper {
                    ${props.cardData?.length <= 2
                        ?
                        `justify-content: space-around !important`
                        :
                        `justify-content: space-between !important`}
                }

                .swiper-pagination-bullet {
                border-radius: 0 !important;
                }
            `}
        </style>

            <FastViewModal
                show={modalData.show}
                id={modalData.id}
                loading={modalData.loading}
                setModalData={setModalData}
                onHide={() => {
                    setModalData((prev) => {
                        return { ...prev, show: false };
                    })
                }} />

            <Swiper
                className="mySwiper"
                style={{ height: "615px" }}
                breakpoints={{
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                    },
                }}
                modules={[Autoplay, Pagination]}
                autoplay={{
                    delay: 7000,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                loop={true}
            >
                <>
                    {props.filterHomeBtns.filterBuy ?
                        props.cardData?.map((item) => (
                            <SwiperSlide key={item.id}>
                                <div onClick={() => modalHandler(item.id)} className={`d-flex align-items-center justify-content-center ${styles.fastview_btn}`} dir="rtl">
                                    <span className='ms-1'>
                                        مشاهده سریع
                                    </span>
                                    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M1.01662 7.16448C4.06662 2.79251 8.02127 0.5 11.9831 0.5C16.6362 0.5 20.6443 3.53129 23.0091 7.18363L23.0102 7.18535C23.1667 7.4285 23.2499 7.71155 23.2499 8.0007C23.2499 8.28933 23.167 8.57187 23.0111 8.81473C20.6483 12.5141 16.6661 15.5 11.9831 15.5C7.25032 15.5 3.34483 12.5203 0.987915 8.83171C0.827766 8.58304 0.744702 8.29255 0.749197 7.99677C0.753702 7.70025 0.845999 7.41172 1.01443 7.16763L1.01662 7.16448ZM2.24903 8.01956L2.25111 8.02279C4.42804 11.4304 7.91716 14 11.9831 14C16.0036 14 19.5679 11.4195 21.7474 8.0065L21.7489 8.00426C21.7495 8.00319 21.7499 8.00196 21.7499 8.0007C21.7499 8.00017 21.7498 7.99965 21.7497 7.99914C21.7496 7.9985 21.7493 7.99787 21.749 7.9973C19.5611 4.61915 15.9676 2 11.9831 2C8.63897 2 5.09927 3.93555 2.24903 8.01956ZM11.9991 5C10.3422 5 8.99907 6.34315 8.99907 8C8.99907 9.65685 10.3422 11 11.9991 11C13.6559 11 14.9991 9.65685 14.9991 8C14.9991 6.34315 13.6559 5 11.9991 5ZM7.49907 8C7.49907 5.51472 9.51379 3.5 11.9991 3.5C14.4844 3.5 16.4991 5.51472 16.4991 8C16.4991 10.4853 14.4844 12.5 11.9991 12.5C9.51379 12.5 7.49907 10.4853 7.49907 8Z" fill="#1D1D1D" />
                                    </svg>
                                </div>
                                <Link to={{
                                    pathname: `/فایل/${item.slug}`,
                                    state: {
                                        state: item
                                    }
                                }} dir='rtl' className={`d-flex align-items-center flex-column px-2 py-2 mt-3 mb-4 text ${styles.slider_card_container}`}>
                                    <div className='w-100 position-relative mb-3 px-2'>
                                        <img className={styles.card_img} loading="lazy" src={`https://backdev.azrmelk.com${item.imageUrl}`} alt={item.title} />

                                    </div>
                                    <div className='w-100 text-end px-2 mb-1'>
                                        <Link to={{
                                            pathname: `/فایل/${item.slug}`,
                                            state: {
                                                state: item
                                            }
                                        }}><h3 className={`d-block ${styles.card_title}`}>{e2p(item.title)}</h3></Link>
                                    </div>

                                    <div className="w-100 d-flex flex-column justify-content-center align-items-center align-items-md-start px-2 flex-wrap">
                                        <h4 className={styles.card_price}>{e2p(props.usePriceSeprator(item.totalPrice))}<span className={`me-1 ${styles.card_text2}`}>تومان</span></h4>
                                        <h4 className={`d-flex align-items-center justify-content-center mt-2 ${styles.card_text2}`}>
                                            {e2p(props.usePriceSeprator(item.meteragePrice))} تومان هر متر مربع
                                        </h4>
                                    </div>
                                    <div className="w-100 d-flex justify-content-around align-items-center px-2 flex-wrap mb-4">
                                        {
                                            getFieldsBasedOnType(item)
                                        }
                                        
                                    </div>
                                    {/* <hr /> */}
                                    <div className={styles.card_hr}></div>

                                    <div className='w-100 d-flex align-items-center justify-content-center mt-3'>
                                        <img src={phoneIcon} alt="icon" />
                                        <button className={styles.text_primary} style={{border: "0", background: "none"}}>
                                            تماس با مشاور
                                        </button>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        ))
                        :
                        props.cardData?.map((item) => (
                            <SwiperSlide key={item.id}>
                                <div onClick={() => modalHandler(item.id)} className={`d-flex align-items-center justify-content-center ${styles.fastview_btn}`} dir="rtl">
                                    <span className='ms-1'>
                                        مشاهده سریع
                                    </span>
                                    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M1.01662 7.16448C4.06662 2.79251 8.02127 0.5 11.9831 0.5C16.6362 0.5 20.6443 3.53129 23.0091 7.18363L23.0102 7.18535C23.1667 7.4285 23.2499 7.71155 23.2499 8.0007C23.2499 8.28933 23.167 8.57187 23.0111 8.81473C20.6483 12.5141 16.6661 15.5 11.9831 15.5C7.25032 15.5 3.34483 12.5203 0.987915 8.83171C0.827766 8.58304 0.744702 8.29255 0.749197 7.99677C0.753702 7.70025 0.845999 7.41172 1.01443 7.16763L1.01662 7.16448ZM2.24903 8.01956L2.25111 8.02279C4.42804 11.4304 7.91716 14 11.9831 14C16.0036 14 19.5679 11.4195 21.7474 8.0065L21.7489 8.00426C21.7495 8.00319 21.7499 8.00196 21.7499 8.0007C21.7499 8.00017 21.7498 7.99965 21.7497 7.99914C21.7496 7.9985 21.7493 7.99787 21.749 7.9973C19.5611 4.61915 15.9676 2 11.9831 2C8.63897 2 5.09927 3.93555 2.24903 8.01956ZM11.9991 5C10.3422 5 8.99907 6.34315 8.99907 8C8.99907 9.65685 10.3422 11 11.9991 11C13.6559 11 14.9991 9.65685 14.9991 8C14.9991 6.34315 13.6559 5 11.9991 5ZM7.49907 8C7.49907 5.51472 9.51379 3.5 11.9991 3.5C14.4844 3.5 16.4991 5.51472 16.4991 8C16.4991 10.4853 14.4844 12.5 11.9991 12.5C9.51379 12.5 7.49907 10.4853 7.49907 8Z" fill="#1D1D1D" />
                                    </svg>
                                </div>
                                <Link to={{
                                    pathname: `/فایل/${item.slug}`,
                                    state: {
                                        state: item
                                    }
                                }} dir='rtl' className={`d-flex align-items-center flex-column px-2 py-2 mt-3 mb-4 ${styles.slider_card_container}`}>
                                    <div className='w-100 position-relative mb-3 px-2'>
                                        <img className={styles.card_img} loading="lazy" src={`https://backdev.azrmelk.com${item.imageUrl}`} alt="card-img" />
                                    </div>
                                    <div className='w-100 text-end px-2 mb-1'>
                                        <Link to={{
                                            pathname: `/فایل/${item.slug}`,
                                            state: {
                                                state: item
                                            }
                                        }} className={`d-block ${styles.card_title}`}>{e2p(item.title)}</Link>
                                    </div>

                                    <div className="w-100 d-flex flex-column justify-content-center align-items-center align-items-md-start px-2 flex-wrap">
                                        <div className='w-100 d-flex align-items-center justify-content-center justify-content-md-start mb-2'>
                                            <div className={`ms-2 ${styles.rent_title}`}>
                                                رهن:
                                            </div>
                                            <div className={styles.card_price}>
                                                {e2p(props.usePriceSeprator(item.mortgagePrice))}<span className={`mb-0 me-1 ${styles.card_text2}`}>تومان</span>
                                            </div>
                                        </div>
                                        <div className='w-100 d-flex align-items-center justify-content-center justify-content-md-start mb-2'>
                                            <div className={`ms-2 ${styles.rent_title}`}>
                                                اجاره:
                                            </div>
                                            <div className={styles.card_price}>
                                                {e2p(props.usePriceSeprator(item.rentPrice))}<span className={`mb-0 me-1 ${styles.card_text2}`}>تومان</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-100 d-flex justify-content-around align-items-center px-2 flex-wrap mb-4">
                                        <div className='d-flex align-items-center justify-content-center flex-column ms-md-5 ms-0'>
                                            <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                                <img className="ms-2" src={bedIcon} alt="icon" />
                                                <div className={styles.card_text2}>
                                                    {e2p(item.roomCount?.toString())} خوابه
                                                </div>

                                            </div>
                                            <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                                <img className="ms-2" src={meterIcon} alt="icon" />
                                                <div className={styles.card_text2}>
                                                    {e2p(item.meterage?.toString())} متر
                                                </div>

                                            </div>
                                        </div>
                                        <div className='d-flex align-items-center justify-content-center flex-column me-md-5 me-0'>
                                            <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                                <img className="ms-2" src={buildingIcon} alt="icon" />
                                                <div className={styles.card_text2}>
                                                    {item?.floor == "0" ?
                                                        "همکف"
                                                        :
                                                        item?.floor == "-1" ?
                                                            "زیرزمین"
                                                            :
                                                            <>
                                                                طبقه {e2p(item.floor?.toString())}
                                                            </>
                                                    }
                                                </div>

                                            </div>
                                            <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                                <img className="ms-2" src={locationIcon} alt="icon" />
                                                <div className={styles.card_text2}>
                                                    {item.address.zone}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.card_hr}></div>

                                    <div className='w-100 d-flex align-items-center justify-content-center mt-3'>
                                        <img src={phoneIcon} alt="icon" />
                                        <div className={styles.text_primary}>
                                            تماس با مشاور
                                        </div>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        ))
                    }
                </>
            </Swiper>
        </>
    );
};

export default HomeFilesSlider;